<template>
    <div ref="settingsTabItems" v-if="auth.user">
        <div>
            <div class="mb-3" v-if="accountUpdateMessage">
                <div class="alert alert-info alert-dismissible fade show" role="alert">
                    <span v-html="accountUpdateMessage"></span> 
                    <button type="button" class="btn-close" @click="(event) => accountUpdateMessage = ''" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>

            <div class="mb-4">
                <label for="email" class="form-label d-flex align-items-center">
                    <span>Email Address</span> 
                    <span v-if="auth && auth.has_verified_email" class="d-flex align-items-center badge badge-success p-1 ms-2">
                        <i class="me-2 bi bi-check-circle p-0 h-auto w-auto" style="font-size: 16px;"></i> <span>Verified</span>
                    </span>
                    <span v-else class="d-flex align-items-center badge badge-danger p-1 ms-2">
                        <i class="me-2 bi bi-exclamation-triangle p-0 h-auto w-auto" style="font-size: 16px;"></i> <span>Not Verified</span>
                    </span>
	                <small>
		                <a href="javascript:void(0)" @click="startChangeEmail" class="text-primary ms-3">Change Email Address</a>
	                </small>
                </label>
	            <div class="position-relative">
                    <input type="email" :readonly="true" :disabled="true" v-model="user.email" class="form-control form-control-lg" id="email" placeholder="name@example.com">
		            <span class="rounded-circle view_toggle" v-tooltip="'View Email'">
                        <i @click="startViewEmail" class="bi bi-eye-slash"></i>
                    </span>
	            </div>
	            <p v-if="auth && !auth.has_verified_email" class="text-muted small">
                    Your email is not verified. Please check your email inbox or junk/spam folder to verify your email address OR <span @click="resend" class="cursor-pointer text-primary">Resend a new verification email.</span>
                </p>
            </div>

            <div class="mb-4">
                <label for="username" class="form-label">
	                <span>Username</span>
	                <small>
		                <a href="javascript:void(0)" @click="startChangeUsername" class="text-primary ms-3">Change Username</a>
	                </small>
                </label>
                <input type="text" :readonly="true" :disabled="true" v-model="username" name="username" id="username" class="form-control form-control-lg">
	            <p class="text-muted mb-3 fs-sm">
		            Do not use a username that can be associated with, or identify yourself as an individual, such as your real name, email or location
	            </p>
            </div>

	        <div class="mb-4">
		        <span>
			        <a href="javascript:void(0)" @click="startChangePassword" class="btn btn-outline-dark rounded-pill">Change Account Password</a>
		        </span>
	        </div>
        </div>

        <hr v-if="!auth.is_admin" />
        
        <div v-if="!auth.is_admin" class="my-4">
            <button type="button" class="btn btn-danger rounded-pill" @click="startDeleteAccount" v-ripple>Request Account Deletion</button>
        </div>
    </div>

	<AuthenticatedActionModal :action="authAction" :consider-trusted-device="considerTrustedDevice" v-if="showActionModal && authAction" :reload-user="reloadUser" @close-modal="closeAuthActionModal"></AuthenticatedActionModal>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useAuthStore } from "@/stores/auth-store.js";
import { useAppHelpers } from '@/composables/useAppHelpers.js';
import AuthenticatedActionModal from "@/components/GenericModalAndViews/AuthenticatedActionModal.vue";

const auth = useAuthStore();
const helper = useAppHelpers();

const user = ref(auth?.user);
const username = ref(auth?.user?.username);

watch(() => auth.user, (newVal) => {
	user.value = newVal;
	username.value = newVal?.username;
});

onMounted(() => {
	user.value = auth?.user;
	username.value = auth?.user?.username;
});

const showActionModal = ref(false);
const considerTrustedDevice = ref(true);
const reloadUser = ref(true);
const authAction = ref('');

const closeAuthActionModal = () => {
	authAction.value = '';
	showActionModal.value = false;
	reloadUser.value = true;
	considerTrustedDevice.value = true;
}

const startChangeEmail = () => {
	authAction.value = 'email_change';
	considerTrustedDevice.value = true;
	showActionModal.value = true;
}

const startViewEmail = () => {
	authAction.value = 'email_view';
	considerTrustedDevice.value = true;
	reloadUser.value = false;
	showActionModal.value = true;
}

const startChangeUsername = () => {
	authAction.value = 'username_change';
	considerTrustedDevice.value = true;
	showActionModal.value = true;
}

const startChangePassword = () => {
	authAction.value = 'password_change';
	considerTrustedDevice.value = false;
	showActionModal.value = true;
}

const startDeleteAccount = () => {
	authAction.value = 'delete_account';
	considerTrustedDevice.value = false;
	showActionModal.value = true;
}

const accountUpdateMessage = ref('');

const settingsTabItems = ref(null);
onMounted(() => {
    helper.loaderOn(settingsTabItems.value);
    setTimeout(() => {
        helper.loaderOff(settingsTabItems.value);
    }, 500);
});

const variables = ref({
    min_questions_answered_avoid_auto_deletion: 3,
    min_questions_answered_stats_calculate: 8
});

</script>

<style lang="scss" scoped>
.view_toggle {
	position: absolute;
	top: 5px;
	right: 0;
}
</style>